import { render, staticRenderFns } from "./headerState.vue?vue&type=template&id=0fd8c0cc&"
import script from "./headerState.vue?vue&type=script&lang=js&"
export * from "./headerState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports